import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loading } from "@/components/Bits";
import { NoAccess } from "@/components/AppShell";

export default function WorkspaceHome() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const modules = user?.modules || [];

  useEffect(() => {
    if (!user) return;
    const destination = ["hospital", "lab", "pharmacy"].find((m) => modules.includes(m) && user.permissions?.[`${m}.dashboard`]);
    navigate(destination ? `/app/${destination}` : "/app/attendance", { replace: true });
  }, [user, modules, navigate]);

  if (!user) return <Loading />;
  if (!modules.length) return <NoAccess what="any business module" />;
  return <Loading label="Opening your workspace…" />;
}
